var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro-page"},[_c('div',{staticClass:"a item",on:{"click":function($event){return _vm.handleTo(1)}}}),_c('div',{staticClass:"b item",on:{"click":function($event){return _vm.handleTo(2)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }